import { useFlags } from "launchdarkly-react-client-sdk";

/** Swaps the Definitions list-and-pane page for the shared Knowledge list and detail pages. */
export function useDefinitionsKnowledgeRefreshEnabled(): boolean {
  const { agentDefinitionsKnowledgeRefresh } = useFlags();
  return Boolean(agentDefinitionsKnowledgeRefresh);
}
